// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"5caadb77","100":"f7756cbe","220":"a2001178","662":"9154881a","857":"e291e100","986":"ee520077"}[chunkId] + ".chunk.js";
};